var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessageCircle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 2.83a.667.667 0 0 1 .703-.629 6.32 6.32 0 0 1 5.964 6v.332a6.254 6.254 0 0 1-.671 2.834 6.332 6.332 0 0 1-5.662 3.5.667.667 0 1 1-.001-1.333 5 5 0 0 0 4.47-2.765l.002-.002c.35-.692.53-1.457.528-2.231v-.317A4.987 4.987 0 0 0 8.63 3.533.667.667 0 0 1 8 2.83Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.332 3.534a4.92 4.92 0 0 0-2.231.528l-.003.001a5 5 0 0 0-2.765 4.471v.002a4.92 4.92 0 0 0 .529 2.23c.08.16.093.343.037.512l-.845 2.535 2.535-.845a.667.667 0 0 1 .512.037 4.92 4.92 0 0 0 2.23.529.667.667 0 1 1 .004 1.333 6.255 6.255 0 0 1-2.58-.55L2.212 15.5a.667.667 0 0 1-.844-.844l1.182-3.545A6.333 6.333 0 0 1 5.5 2.871a6.253 6.253 0 0 1 2.835-.67.667.667 0 1 1-.003 1.333Z",
  clipRule: "evenodd"
})));
SvgMessageCircle.viewBox = '0 0 16 17';
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessageCircle);
export default ForwardRef;